<script setup lang="ts">
defineProps<{ prefix: string; stacked: boolean }>();
</script>
<template>
  <span
    class="heading-name-edit"
    :class="{ 'heading-name-edit-stacked': stacked }"
  >
    <span v-if="prefix.length > 0" class="heading-name-prefix">{{
      prefix.trimEnd()
    }}</span>
    <slot />
  </span>
</template>
<style scoped>
.heading-name-edit {
  display: flex;
  align-items: center;
  gap: 0.25em;
  flex: 1;
  min-width: 0;
}
.heading-name-prefix {
  flex: 0 0 auto;
  white-space: nowrap;
}
.heading-name-edit :deep(.zw-input-shell) {
  flex: 1;
  min-width: 0;
}
.heading-name-edit-stacked {
  flex-direction: column;
  align-items: stretch;
}
</style>
